<template>
  <div v-if="model">
    <div class="layout">
        <Sider :style="{position: 'fixed', height: '100vh', left: 0, overflow: 'auto', width: '320px', 'min-width': '320px'}">
          <domain-menu ref="domainMenu" :current="current" :state="model" :batch="batch"></domain-menu>
        </Sider>
        <Layout :style="{marginLeft: '330px'}">
          <Card>
          <p slot="title">
            <strong>{{ model.visitName }} # {{ model.domainName }} </strong>
          </p>

          <Row class="form-instructions" v-if="model.instructions">
            <Col>
              <strong>填写说明</strong>
              {{ model.instructions }}
            </Col>
          </Row>
          <edit-domain :items="items" :seq="null" :model="model" v-if="model.repeated === 0">
          </edit-domain>
          <edit-multi-domain :items="items" :model="model" v-if="model.repeated === 1" @refresh="fetchData"></edit-multi-domain>
        </Card>
        </Layout>
    </div>
  </div>
</template>

<script>
import { ViewDomain } from '@/api/subject'
import DomainMenu from '@/components/subject/DomainMenu'
import EditDomain from '@/components/subject/EditDomain'
import EditMultiDomain from '@/components/subject/EditMultiDomain'

export default {
  name: 'view-form',
  data: () => ({
    model: null,
    batch: null,
    varMeta: null,
    vid: null,
    items: {}
  }),
  created: function () {
    this.fetchData()
  },
  computed: {
    current: function () {
      return this.$route.params.stateid
    },
    vars: function () {
      if (this.model.repeated === 1) {
        var model = []
        for (var i = 0; i < this.items[0].length; i++) {
          model[i] = JSON.parse(JSON.stringify(this.items[0][i]))
          model[i].data.val = null
        }
        return model
      } else {
        return this.items
      }
    }
  },
  watch: {
    $route (to, from) {
      this.fetchData()
    }
  },
  components: {
    'domain-menu': DomainMenu,
    'edit-domain': EditDomain,
    'edit-multi-domain': EditMultiDomain
  },
  methods: {
    fetchData: function () {
      const id = this.$route.params.stateid
      ViewDomain(id).then(async res => {
        this.model = res.model
        this.batch = res.model.batch
        this.items = res.items
      })
    }
  }
}
</script>

<style>
.view-var {
  padding: 10px;
  min-height: 48px;
  border-bottom: 1px solid #dbdbdb;
}
.form-header {
  padding: 10px;
  background-color: #FFFFFF;
  margin-bottom: 20px;
  margin-right: 10px;
}
.form-item-actions {
  display: inline;
  padding: 6px 20px 0 40px;
  letter-spacing: 6px;
}
.form-instructions {
  padding: 10px;
  background-color: #ebe9ea;
  border-bottom: 1px solid #dbdbdb;
}
</style>
